import React from 'react';
import { Link } from 'react-router-dom';

import { AgentProfile, Button, DescriptionText, Icon, Space } from 'components';
import type { OfferNotificationTask } from '@/app-package';

import ListingSection from './ListingSection';
import TaskLayout from './TaskLayout';

type OfferRegisteredItemProps = { itemData: OfferNotificationTask['data'] };

const OfferRegisteredItem: React.FC<OfferRegisteredItemProps> = ({
  itemData,
}) => (
    <TaskLayout
      title="Offer Registered"
      content={
        <Space direction="vertical">
          <ListingSection
            data-cy="offer-registered-listing-data"
            listing={{
              line1: itemData.line1,
              line2: itemData.line2,
              thumbnail: itemData.thumbnail,
            }}
          />
          <AgentProfile user={itemData.coop} showOrgName nameTextStrong />
          {itemData.offerCount > 1 && (
            <DescriptionText data-cy="offer-registered-count">
              {itemData.offerCount} Offers total
            </DescriptionText>
          )}
        </Space>
      }
      buttons={
        <Link
          to={`/listing/${itemData.listingId}/offer/?manageNotifications=true`}
          data-cy="offer-registered-notifications"
        >
          <Button
            size="small"
            icon={
              <Icon
                type="antdSettingOutlined"
                width={14}
                offset={[0, -2]}
                color="gray8"
              />
            }
          >
            Manage Notifications
          </Button>
        </Link>
      }
      dataCy={`offer-registered-task-item`}
    />
  );

export default OfferRegisteredItem;
